// Shared Task ID / title search matcher — single source of truth reused by
// Task Table, Developer Queue, UI/UX Design Queue and Manager Approval so
// search behaves identically everywhere (full or partial Task ID, title
// text, case-insensitive, leading/trailing whitespace ignored).
export const matchesTaskSearch = (task, searchTerm) => {
  const term = (searchTerm || '').trim().toLowerCase();
  if (!term) return true;
  return (
    (task?.task || '').toLowerCase().includes(term) ||
    (task?.task_id || '').toLowerCase().includes(term)
  );
};
